(function() {
    angular
        .module("devicesModule")
        .controller("DeviceMessageBoardNewController", DeviceMessageBoardNewController)

    DeviceMessageBoardNewController.$inject = [
        "$state",
        "$stateParams",
        "$rootScope",
        "$scope",
        "$uibModal",
        "messageBoardsService",
        "userMessagingService"
    ]

    function DeviceMessageBoardNewController(
        $state,
        $stateParams,
        $rootScope,
        $scope,
        $uibModal,
        messageBoardsService,
        userMessagingService
    ){
        "use strict"

        /**
            $scope variables
         **/
        $scope.loading        = false
        $scope.hasOneCustomer = true
        $scope.ignoreDuplicateIPs = false

        $scope.hasOneCustomer = $rootScope.customers.length == 1

        $scope.units = [
            {value: "mi", label: "mi"},
            {value: "km", label: "km"}
        ]

        $scope.transportOptions = [
            {value: "PMPP",     label: "PMPP"},
            {value: "SNMP_UDP", label: "SNMP via UDP"},
            {value: "SNMP_TCP", label: "SNMP via TCP"}
        ]

        $scope.manufacturers = [
            {value: "Wanco",   label:"Wanco"},
            {value: "Ver-Mac", label:"Ver-Mac"}
        ]

        $scope.newDeviceFormData = {
            manufacturer: $scope.manufacturers[0].value,
            transport:    $scope.transportOptions[0].value
        }

        $scope.newDeviceFormData.customer_id = $rootScope.selectedCustomerID

        $scope.newDeviceTypeName = "Message Board"
        if ($stateParams.type && $stateParams.type === "speedLimitTrailer") {
            $scope.newDeviceTypeName = "Speed Limit Trailer"
        }
        $rootScope.title = "New " + $scope.newDeviceTypeName + " | WANCO"

        gtag("event", "create_device", { action: "begin", type: $stateParams.type })

        $scope.cancel = () => gtag("event", "create_device", { action: "cancel", type: $stateParams.type })

        /**
            Create new message board
         **/
        $scope.createDevice = () => {

            $scope.submitted = true

            if ($scope.newDeviceForm.$valid) {

                $scope.loading = true

                const success = (data) => {

                    $scope.loading = false
                    $scope.ignoreDuplicateIPs = false

                    if (data !== undefined && data.hasOwnProperty("has_duplicate_devices") && data.has_duplicate_devices) {

                        $uibModal.open({
                            templateUrl: "app/modals/duplicate-device-ip-modal.view.html",
                            controller:  "DuplicateDeviceIpModalController",
                            resolve: {
                                duplicateDevices: function() {
                                    return data.duplicate_devices
                                },
                                createDuplicate: () => {
                                    return () => {
                                        $scope.ignoreDuplicateIPs = true
                                        $scope.createDevice()
                                    }
                                },
                                actionText: () => {
                                    return "Create Duplicate"
                                }
                            }
                        }).result.catch(function(res) {

                            $scope.ignoreDuplicateIPs = false

                            if (!(res === "cancel" || res === "escape key press")) {
                                throw res
                            }
                        })

                        return

                    }

                    if (data && data.device) gtag("event", "create_device", { action: "complete", device_id: data.device.id, type: $stateParams.type })

                    $state.go("devices", {}).then(() => {
                        userMessagingService.success($scope.newDeviceTypeName + " Successfully Created")
                    })
                }

                const failure = (error) => {

                    $scope.loading = false
                    $scope.ignoreDuplicateIPs = false

                    if(error.hasOwnProperty("data")) {
                        if(error.data.hasOwnProperty("errors")) {
                            angular.forEach(error.data.errors, (value, key) => {
                                if(key == "conn.ip") {
                                    userMessagingService.error("Connection IP " + value + ".", true)
                                    $scope.newDeviceForm.ip.$invalid = true
                                } else if(angular.isNumber(key)) {
                                    userMessagingService.error(value + ".")
                                } else {
                                    userMessagingService.error(key + " " + value + ".")
                                }
                            })
                        }
                    } else {
                        userMessagingService.error($scope.newDeviceTypeName + " Creation Failed")
                    }
                }

                messageBoardsService.createMessageBoard(angular.fromJson($scope.newDeviceFormData), $scope.ignoreDuplicateIPs, success, failure)

            }
        }
    }
})()
